import React from 'react';

export default function Story(props) {

  var d = props.direction;
  var p = props.prev;
  var s = props.show;
  var n = props.next;

  let content = []
  if (d === 'next') {
    if (p !== 'no') {
      content.push(returnStoryJSX(p, 'nextOut', props.page-1))
    }
    if (p && s !== 'no') {
      content.push(returnStoryJSX(s, 'nextIn', props.page))
    }
    if (!p) {
      content.push(returnStoryJSX(s, 'static', props.page))
    }
  } else if (d === 'prev') {
    if (n !== 'no') {
      content.push(returnStoryJSX(n, 'prevOut', props.page+1))
    }
    if (s !== 'no') {
      content.push(returnStoryJSX(s, 'prevIn', props.page))
    }
  }

  function returnStoryJSX (what, how, page) {
    if (Array.isArray(what)) { // this is the case when comparing 1988 with 2018
      return (
        <div className={'story ' + how + (page%2 === 0 ? 'Odd' : 'Even') + ' page' + props.page } key={how} id={'story-' + how }>
          <span>{what[0]}</span>
          <span className="opa5"> {what[1]} </span>
          <span>{what[2]}</span>
        </div>
      )
    } else if (what) {
      return (
        <div className={'story ' + how + (page%2 === 0 ? 'Odd' : 'Even') + ' page' + props.page } key={how} id={'story-' + how} >{what}</div>
      )
    } else {
      return null;
    }
  }

  return (
    <div className="storyWrapper" id={'story-' + props.page}>
      {content}
    </div>
  )

};
